import i18n from '../../../../../i18n';
import { toRaw, defineAsyncComponent } from 'vue';
import { checkAttribute, initUseForm, putField } from '../../../../../utils/form';
import { useForm as createUseForm } from '@ant-design-vue/use';
import { routerPrefix, callSearch } from '../physical-analysis-topic/physical-analysis-topic-table.logic';

export const { isLoading, setIsLoading } = createLoading();

import {
    required,
/*
    requiredWhen,
*/
    validateError
} from '../../../../../utils/validate';
import store from '../../../../../store';

import {
    createFieldRadioGroup
} from '../../../../../components/input/template-builder/template-builder.logic';
import { createFieldInputNumber } from '../../../../../components/input/template-builder/template-builder.logic';
import { setAllCalInput, setInputAccept } from './physical-analysis-topic-input-table.logic';
import { createLoading } from '../../../../../utils/loading';

export const PhysicalAnalysisTopicInputTable = defineAsyncComponent(() => import('./PhysicalAnalysisTopicInputTable'));

export const callAcceptStatus = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: 'ACCEPT_STATUS',
    value: searchQuery
});

export const createFormTitle = ({ data }) => {
    return data.useForm?.modelRef?.id ? data.useForm.modelRef.name : i18n.global.t('button.create');
};

export const updateTableTopicInput = ({ data, fieldKey, value, acceptStatus, itemsKey }) => {
    data?.useForm?.modelRef[itemsKey]?.forEach(record => {
        record[fieldKey] = value;
        record.isSave = true;
        setAllCalInput({ record });
        setInputAccept({ record, modelRef: data?.useForm?.modelRef, itemsKey, acceptStatus });
    });
};

export const createField = ({ props, data }) => {
    const { viewOnly, menuContext, parent, acceptStatus } = props;
    const { itemsKey } = data;
    const { useForm } = data;
    const { modelRef } = useForm;
    return putField({
        data, fields: [
            createFieldInputNumber({
                key: `thicknessEnd`,
                // visible: () => itemsKey == 'inputs' && modelRef.refLabTopic?.refLabFormula?.key == 'Integrity',
                visible: () => false,
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessEnd'),
                inputProp: () => ({
                    value: modelRef.thicknessEnd,
                    'onUpdate:value': value => {
                        modelRef.thicknessEnd = value;
                        updateTableTopicInput({ data, fieldKey: 'thicknessEnd', value, itemsKey, acceptStatus });
                    },
                    comma: false,
                    allowPrecision: true
                })
            }),
            createFieldInputNumber({
                key: `thicknessBody`,
                // visible: () => itemsKey == 'inputs' && modelRef.refLabTopic?.refLabFormula?.key == 'Integrity',
                visible: () => false,
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessBody'),
                inputProp: () => ({
                    value: modelRef.thicknessBody,
                    'onUpdate:value': value => {
                        modelRef.thicknessBody = value;
                        updateTableTopicInput({ data, fieldKey: 'thicknessBody', value, itemsKey, acceptStatus });
                    },
                    comma: false,
                    allowPrecision: true
                })
            }),
            createFieldInputNumber({
                key: `seamThickness`,
                // visible: () => itemsKey == 'inputs' && modelRef.refLabTopic?.refLabFormula?.key == 'Integrity',
                visible: () => false,
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.seamThickness'),
                inputProp: () => ({
                    value: modelRef.seamThickness,
                    'onUpdate:value': value => {
                        modelRef.seamThickness = value;
                        updateTableTopicInput({ data, fieldKey: 'seamThickness', value, itemsKey, acceptStatus });
                    },
                    comma: false,
                    allowPrecision: true
                })
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <PhysicalAnalysisTopicInputTable
                    menuContext={menuContext}
                    viewOnly={viewOnly}
                    root={parent}
                    parent={modelRef}
                    parentData={data}
                    useForm={useForm}
                    acceptStatus={acceptStatus}
                    itemsKey={`${ itemsKey }`}
                    actionPrefix={data.actionPrefix}
                    fetchCriteria={data.fetchCriteria}
                    onLoadedData={(page) => {
                        if (page?.data?.length > 0) {
                            modelRef.thicknessEnd = page.data[0].thicknessEnd;
                            modelRef.thicknessBody = page.data[0].thicknessBody;
                            modelRef.seamThickness = page.data[0].seamThickness;
                        }
                    }}
                >
                </PhysicalAnalysisTopicInputTable>
            },
            createFieldRadioGroup({
                visible: () => true,
                key: `refTopicAnalysisStatus`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopic.refTopicAnalysisStatus'),
                inputProp: () => ({
                    value: modelRef.refTopicAnalysisStatus,
                    'onUpdate:value': value => modelRef.refTopicAnalysisStatus = value,
                    disabled: viewOnly,
                    list: ({ searchQuery }) => callAcceptStatus({ searchQuery }).then(arr => arr.filter(it => it.key != 'RejectCanRepeat')),
                    optLabel: 'value'
                })
            })

        ]
    });
};

export const createSearchOneCriteria = ({ id, forLog, data }) => {
    if (!forLog) {
        return {
            select: ['**'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [
                {
                    name: `${data.itemsKey}`, page: 0, size: 10000, select: ['**']
                }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }]
        };
    }
};

export const createForm = () => {
    return {
        thicknessEnd: null,
        thicknessBody: null,
        seamThickness: null,
        refSamplingProductAnalysis: null,
        refLabTopic: null,
        refAttachment: null,
        isTransfer: null,
        sub: null,
        refTopicAnalysisStatus: null,
        refTopicRepeatOption: null,
        inputs: [],
        children: []
    };
};

export const createRules = (/*{ data }*/) => {
/*
    const { itemsKey } = data;
*/
    return {
        /*  thicknessEnd: [requiredWhen({ when: () => itemsKey == 'inputs' && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'Integrity' })],
          thicknessBody: [requiredWhen({ when: () => itemsKey == 'inputs' && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'Integrity' })],
          seamThickness: [requiredWhen({ when: () => itemsKey == 'inputs' && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'Integrity' })],*/

        thicknessEnd: [],
        thicknessBody: [],
        seamThickness: [],
        refLabTopic: [required],
        refAttachment: [],
        isTransfer: [],
        sub: [],
        refTopicAnalysisStatus: [],
        refTopicRepeatOption: [],
        inputs: [],
        children: []
    };
};


export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id, props, data }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then((page) => {
            initUseForm({ data, page, routerPrefix });
        }).finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};


export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    if (props.form?.refLabTopic?.haveChildren) {
        data.itemsKey = 'children';
    } else {
        data.itemsKey = 'inputs';
    }
    data.form = createForm();
    data.rules = createRules({ data });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ data, props, refs });
    if (data.id) {
        if (props.form.refLabTopic.haveChildren && props.form.refLabTopic.refLabFormula.key == 'Acceptance') {
            data.actionPrefix = 'resource/v1/transaction/samplingProductAnalysisTopic';
            data.fetchCriteria = {
                page: 0,
                size: 10000,
                select: ['**'],
                where: [{
                    name: 'refParent.id',
                    operator: '=',
                    type: 'UUID',
                    value: data.id
                }]
            };
        } else {
            data.actionPrefix = 'resource/v1/transaction/samplingProductAnalysisTopicInput';
            data.fetchCriteria = {
                page: 0,
                size: 10000,
                select: ['**'],
                where: [{
                    name: 'refSamplingProductAnalysisTopic.id',
                    operator: '=',
                    type: 'UUID',
                    value: data.id
                }],
                sort: [{ name: "createDate", type: "ASC" }],
            };
        }
    }
    loadForm({ props, data, refs });
};


